import { Equipment } from '../types/equipment';
import api from './api';

export async function getEquipment(filters: any = {}) {
    // console.group('getEquipment');
    // console.log('Input Filters:', filters);

    const queryParams = new URLSearchParams();

    // Add filters to query params
    Object.keys(filters).forEach(key => {
        if (filters[key] !== undefined && filters[key] !== '') {
            queryParams.append(key, filters[key].toString());
        }
    });

    const queryString = queryParams.toString();
    // console.log('Query Params:', queryString);

    try {
        const response = await api.get<any>(`/equipment?${queryString}`);

        // console.log('Raw API Response:', response);
        // console.log('Response Data Type:', typeof response.data);
        // console.log('Response Data Keys:', Object.keys(response.data));

        // console.groupEnd();
        return response;
    } catch (error) {
        console.error('API Call Error:', error);
        console.groupEnd();
        throw error;
    }
}

// Filters can include:
// - status: Filter by equipment status
// - type: Filter by equipment type ID
// - subtype: Filter by equipment subtype ID
// - allocated: Filter for allocated/unallocated equipment (true/false)
// - serial_number: Filter by serial number
// - order_number: Filter by order number
// - unassigned: When true, only returns equipment not present in task_equipment table (not assigned to any task)

export async function createEquipment(data: Partial<Equipment>) {
    return api.post<{ data: Equipment; success: boolean }>('/equipment', data);
}

export async function updateEquipment(id: number, data: Partial<Equipment>) {
    return api.put<{ success: boolean }>(`/equipment/${id}`, data);
}

export async function deleteEquipment(id: number) {
    return api.delete<{ success: boolean }>(`/equipment/${id}`);
}

export async function getEquipmentByType(typeId: number) {
    return api.get<{
        success: boolean;
        data: Equipment[]
    }>(`/equipment/${typeId}`);
}

export async function getAllocatedEquipmentByStore(store: string) {
    return api.get<{
        success: boolean;
        data: Equipment[]
    }>(`/equipment/allocated/store/${store}`);
}

export const allocateEquipment = async (jobCardId: number, equipmentId: number, data: {
    allocation_type: 'store' | 'equipment';
    allocated_id?: number;
    store_number?: number;
    allocation_date: string;
    allocation_notes?: string;
    deallocate?: boolean;
}) => {
    try {
        const response = await api.post(`/jobcards/${jobCardId}/equipment/${equipmentId}/allocate`, data);
        return response.data;
    } catch (error) {
        console.error('Error allocating equipment:', error);
        throw error;
    }
};

export async function getEquipmentByOrderNumber(orderNumber: string) {
    return api.get<{
        success: boolean;
        data: Equipment[]
    }>(`/equipment/order/${orderNumber}`);
} 